import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import { Geolocation } from '@capacitor/geolocation';
import {CommonService} from "./core/services/common.service";
import {HttpClientService} from "./core/services/http-client.service";

const LOCATION_API = 'https://api.opencagedata.com/geocode/v1/json';
const Key = '8f67415dbf4c457680dec05a25da214f';

@Injectable({
  providedIn: 'root'
})
export class HomepageResolver implements Resolve<any> {
  constructor(
    private common: CommonService,
    private httpService: HttpClientService
  ) {}

  async resolve(route: ActivatedRouteSnapshot) {
    const storeCode = route.queryParams['storeCode'];
    const storedPincode = this.common.getStorage(this.common.pincode);

    if (storeCode) {
      this.getToken(storeCode).subscribe((token: any) => {
        if (token.statusCode == 200) {
          this.common.setStorage(this.common.newToken, token.response.token);
          this.common.setStorage(this.common.pincode, (token.response.pincode) ? token.response.pincode : '110001' );
        }
      });
    } else {
      try {
        if (!storedPincode) {
          const response = await Geolocation.getCurrentPosition();
          await this.getPostalCode(response.coords);
        }
      } catch (err) {
        this.getStoreAddress(storedPincode).subscribe((x) => {
          this.getToken(x.response.toLowerCase()).subscribe((token) => {
            if (token.statusCode == 200) {
              this.common.setStorage(this.common.newToken, token.response.token);
              this.common.setStorage(this.common.pincode, '110001');
              this.common.tokenStream.next('/');
            }
          });
        });
      }
    }

    return this.httpService.get('banner-listing-url?pageUrl=https://store.smartdukaan.com/&websiteName=Store Website').toPromise();
  }

  async getPostalCode(coords: any) {
    try {
      const response = await fetch(`${LOCATION_API}?key=${Key}&q=${coords.latitude},${coords.longitude}`);
      if (response.ok) {
        const res = await response.json();
        const pinCode = res?.results?.[0]?.components?.postcode || '';
        this.common.pincodeChange.next({ pinCode, url: '/' });
        this.common.setStorage(this.common.pincode, pinCode);

        this.getStoreAddress(pinCode).subscribe((x) => {
          this.getToken(x.response.toLowerCase()).subscribe((token) => {
            if (token.statusCode == 200) {
              this.common.setStorage(this.common.newToken, token.response.token);
              this.common.tokenStream.next('/');
            }
          });
        });
      }
    } catch (e) {
      this.getStoreAddress('110001').subscribe((x) => {
        this.getToken(x.response.toLowerCase()).subscribe((token) => {
          if (token.statusCode == 200) {
            this.common.setStorage(this.common.newToken, token.response.token);
            this.common.tokenStream.next('/');
            this.common.setStorage(this.common.pincode, '110001');
          }
        });
      });
    }
  }

  getStoreAddress(pinCode = '') {
    return this.httpService.get(`store/address/${pinCode}`);
  }

  getToken(storeCode: string) {
    return this.httpService.get(`store/token/${storeCode}`);
  }
}
